import React from 'react';
import AnimateOnScroll from './ui/AnimateOnScroll';

const AboutMeSection = () => {
  return (
    <section id="about" className="py-16 bg-white">
      <div className="section-container">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-8 items-center">
          {/* תמונה אליפטית */}
          <div className="md:col-span-4 lg:col-span-3 flex justify-center">
            <AnimateOnScroll animation="animate-fade-in">
              <div className="relative">
                {/* שינוי גודל המיכל והוספת position relative */}
                <div className="w-64 h-64 md:w-56 md:h-56 lg:w-64 lg:h-64 rounded-full overflow-hidden border-4 border-tech-blue shadow-lg relative">
                  {/* שינוי בסגנון התמונה לתיקון הבעיה */}
                  <img 
                    src="/images/111.jpg" 
                    alt="שלומית ז'בנר" 
                    className="absolute w-full h-full object-cover object-center"
                    style={{ top: '50%', left: '50%', transform: 'translate(-50%, -50%)', minWidth: '100%', minHeight: '100%' }}
                  />
                </div>
                <div className="absolute inset-0 rounded-full border-8 border-white opacity-20"></div>
              </div>
            </AnimateOnScroll>
          </div>
          
          {/* תוכן טקסט */}
          <div className="md:col-span-8 lg:col-span-9">
            <AnimateOnScroll animation="animate-fade-in" delay={200}>
              <h2 className="text-2xl md:text-3xl font-bold text-tech-darkGray mb-2">שלומית ז'בנר</h2>
              <h3 className="text-xl font-semibold text-tech-blue mb-4">נעים מאד,</h3>
              
              <div className="text-gray-600 space-y-4 max-w-3xl text-justify">
                <p>
                  אני שלומית - מומחית לאוטומציות עסקיות והנגשת טכנולוגיה לבעלי עסקים. הסיפור המקצועי שלי ייחודי: שנים של ניסיון כמנהלת משאבי אנוש לימדו אותי להבין לעומק את האתגרים של אנשים בסביבת העבודה. שני תארים שניים - בהתנהגות ארגונית ובמידענות - העניקו לי את היכולת המיוחדת לגשר בין העולם האנושי לעולם הטכנולוגי.
                </p>
                
                <p>
                  אני מאמינה שטכנולוגיה צריכה לשרת אותנו, ולא להפך. כמאפיינת ומתכננת מערכות מידע, המומחיות שלי היא בתרגום צרכים עסקיים לפתרונות פשוטים וידידותיים - במיוחד עבור מי שהטכנולוגיה לא "זורמת לו בדם".
                </p>
                
                <p>
                  הגישה שלי משלבת הקשבה עמוקה לצרכים שלכם יחד עם התאמה מדויקת של הפתרונות הטכנולוגיים שיקלו על חיי היומיום בעסק. בואו ניפגש לכוס קפה, בלי מחשבים ובלי מסכים, נשוחח על העסק שלכם, על האתגרים שלכם, ונראה יחד איך אפשר להפוך את הניהול היומיומי של העסק לפשוט יותר - בדיוק בקצב שמתאים לכם.
                </p>
              </div>
            </AnimateOnScroll>
          </div>
        </div>
      </div>
    </section>
  );
};

export default AboutMeSection;